import Base from './Base';

export default class CannedMessage extends Base {
    get substringMessage() {
        const length = 235;
        const substringMessage = this.message
            ? this.message.substring(0, length - 3) + '...'
            : '';

        if (this.message) {
            return this.message.length > length ? substringMessage : this.message;
        }

        return ''
    }

    get hasIntegration() {
        return Boolean(this.integration);
    }

    get integrationKey() {
        if (!this.integration) return null;

        return this.integration.key;
    }

    getValue(_this) {
        if (!this.hasIntegration) return this.value;
        if (_this.hasIntegrationUser(this.integrationKey)) return this.value;

        return this.message;
    }
}
